module.exports = __webpack_public_path__ + "static/media/job_category_16.00b69397.png";